import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs';
import { Configuration } from '../../app.constants';

@Injectable()

export class ImageUploadService {

  constructor(private http: HttpClient, private configuration:Configuration){}


  public uploadImage(image: File,StudentID: number): Observable<string | any> {
    const formData = new FormData();

    formData.append('Image', image);
    formData.append('ImageCaption', "Test");
    //return this.http.post('http://35.200.230.132:8081/api/PreStudentAddressInfo/UploadStudentPhoto?StudentID='+ StudentID, formData).pipe(map(((json: any) =>  json.imageUrl)));
    return this.http.post(this.configuration.serverWithApiUrl +'/PreStudentAddressInfo/UploadStudentPhoto?StudentID='+ StudentID, formData);
  }

  uploadImageSign(fileToUpload: File,StudentID: number) {
    
    //PostStudentSign
    const endpoint = this.configuration.serverWithApiUrl + '/PreStudentAddressInfo/PostStudentSign?StudentID='+ StudentID; 
    const formData: FormData = new FormData();
    formData.append('Image', fileToUpload);
    formData.append('ImageCaption', "Test");
    return this.http
      .post(endpoint, formData);
  }
   uploadFiles(fileToUpload: File,data:any){debugger
    let formData: FormData = new FormData();         

             formData.append('file', fileToUpload, fileToUpload.name);
            //formData.append('model', JSON.parse(JSON.stringify(data)));
            var queryParam="?StudentID=" + data.StudentID + "&StudentDocumentID="+ data.StudentDocumentID + "&DocumentID=" + data.DocumentID + "&CreatedLoginID=" + this.configuration.CreatedLoginID +"&UpdatedLoginID="+this.configuration.UpdatedLoginID+"";
            let apiUrl = this.configuration.serverWithApiUrl +"/PreStudentDocuments/PostInsertPreStudentDocumentsByPara" + queryParam;

            return this.http
            .post(apiUrl, formData);
  }
  uploadFilesForRequest(fileToUpload: File,data:any){debugger
    let formData: FormData = new FormData();


             
             formData.append('file', fileToUpload, fileToUpload.name);
            //formData.append('model', JSON.parse(JSON.stringify(data)));
            var queryParam="?StudentID=" + data.StudentID + "&ApplicationNO="+ data.ApplicationNO + "&ResultQueryCode=" + data.ResultQueryCode+"&ExamInstanceID=" + data.ExamInstanceID + "";
            let apiUrl = this.configuration.serverWithApiUrl +"/PortalBranchChange/UploadRequestDocument" + queryParam;

            return this.http
            .post(apiUrl, formData);
  }
  createFormData(object: Object, form?: FormData, namespace?: string): FormData {
    const formData = form || new FormData();
    for (let property in object) {
        if (!object.hasOwnProperty(property) || !object[property]) {
            continue;
        }
        const formKey = namespace ? `${namespace}[${property}]` : property;
        if (object[property] instanceof Date) {
            formData.append(formKey, object[property].toISOString());
        } else if (typeof object[property] === 'object' && !(object[property] instanceof File)) {
            this.createFormData(object[property], formData, formKey);
        } else {
            formData.append(formKey, object[property]);
        }
    }
    return formData;
}

uploadCertificate(fileToUpload: File,data:any){debugger
  let formData: FormData = new FormData(); 

           formData.append('file', fileToUpload, fileToUpload.name);
          //formData.append('model', JSON.parse(JSON.stringify(data)));
          var queryParam="?StudentID=" + data.StudentID + "&PreStudentPhyInfoID="+ data.PreStudentPhyInfoID + "&CertId=" + data.CertId +"";
          let apiUrl = this.configuration.serverWithApiUrl +"/StudentPhyInfo/PostUploadPhysicalInfoCertificate" + queryParam;

          return this.http
          .post(apiUrl, formData);
}

uploadExtraCertificate(fileToUpload: File,data:any){debugger
  let formData: FormData = new FormData(); 

           formData.append('file', fileToUpload, fileToUpload.name);
          //formData.append('model', JSON.parse(JSON.stringify(data)));
          var queryParam="?StudentID=" + data.StudentID + "&PreStudentOtherCourseID="+ data.PreStudentOtherCourseID +"";
          let apiUrl = this.configuration.serverWithApiUrl +"/StudentPhyInfo/PostUploadCertificateCourse" + queryParam;

          return this.http
          .post(apiUrl, formData);
}


uploadSportsCertificateDtl(fileToUpload: File,data:any){debugger
  let formData: FormData = new FormData(); 

           formData.append('file', fileToUpload, fileToUpload.name); 
          var queryParam="?StudentID=" + data.StudentID + "&PreStudentSportsID="+ data.PreStudentSportsID +"";
          let apiUrl = this.configuration.serverWithApiUrl +"/PreStudentSports/PostUploadSportsCertificateDtl" + queryParam;

          return this.http
          .post(apiUrl, formData);
}


uploadEnrolmentFile(fileToUpload: File,data:any){debugger
  let formData: FormData = new FormData(); 

           formData.append('file', fileToUpload, fileToUpload.name);
          //formData.append('model', JSON.parse(JSON.stringify(data)));
          var queryParam="?StudentID=" + data.StudentID + "&StudentEnrolmentID="+ data.StudentEnrolmentID + "&CertId=" + data.CertId +"";
          let apiUrl = this.configuration.serverWithApiUrl +"/PreStudentEnrolment/PostuploadEnrolmentFile" + queryParam;

          return this.http
          .post(apiUrl, formData);
}
}
